import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Breadcrumbs/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ContentElements/Anchor/AnchorNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ContentElements/Button/CookieLayerLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ContentElements/Directory/Directory.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ContentElements/Map/DynamicMap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsFilter"] */ "/app/src/components/ContentElements/News/NewsFilter/NewsFilter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ContentElements/News/NewsList/NewsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsCounterProvider"] */ "/app/src/components/ContentElements/News/Provider/NewsCounterProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ContentElements/News/Text/NewsTags.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/libs/contentful/helper/FormRenderer.tsx");
